export const TIPOS_GRUPO = ['INDUCCION','ETAPA_PRODUCTIVA','MEJORAMIENTO','EDUCACION_SUPERIOR'];

export function completarFormularioGrupo(form, contexto, tipo) {
  const institucion = contexto.instituciones.find(i=>i.id === form.enteObjectId) || (!form.enteObjectId && contexto.instituciones.length === 1 ? contexto.instituciones[0] : null);
  const instructor = contexto.instructores.find(i=>i.id === form.instructorObjectId) || (!form.instructorObjectId && contexto.instructores.length === 1 ? contexto.instructores[0] : null);
  const datos = {...tipo?.textosFijos,...form.datosEspecificos,programa:contexto.programa,instructor:instructor?.nombre || ''};
  if (tipo?.id === 'ETAPA_PRODUCTIVA') {
    for (const key of ['planeacionInicio','finalFin']) if (!datos[key] && contexto.fechas?.[key]) datos[key]=contexto.fechas[key];
  }
  return {...form,usarDatosGrupo:true,enteObjectId:institucion?.id || '',instructorObjectId:instructor?.id || '',
    institucion:institucion?.nombre || '',ciudad:institucion?.ciudad || contexto.ciudad,
    direccionRegionalCentro:contexto.direccionRegionalCentro,
    lugarEnlace:form.lugarEnlace || institucion?.direccion || institucion?.nombre || '',datosEspecificos:datos};
}
